<script setup>
import { Head } from '@inertiajs/vue3';

defineProps({
    title: String,
});
</script>

<template>
    <div>
        <Head :title="title" />

        <q-layout class="bg-grey-1">
            <q-page-container>
                <q-page>
                    <slot />
                </q-page>
            </q-page-container>
        </q-layout>
    </div>
</template>
